const PREFIX = '[Auth Debug]'
const isDev = import.meta.env.DEV

const noop = () => {}

export const authDebug = {
  loginRequest: isDev
    ? (email: string) => {
        console.group(`${PREFIX} Login Request`)
        console.log('Email:', email)
        console.log('BACKEND_URI:', import.meta.env.VITE_BACKEND_URI)
        console.log('Full URL:', `${import.meta.env.VITE_BACKEND_URI}/auth/login`)
        console.groupEnd()
      }
    : noop,

  loginResponse: isDev
    ? (status: number, headers: Record<string, string>) => {
        console.group(`${PREFIX} Login Response`)
        console.log('Status:', status)
        console.log(
          'Set-Cookie header visible:',
          headers['set-cookie'] ?? 'not visible (HttpOnly)',
        )
        console.log('All response headers:', headers)
        console.groupEnd()
      }
    : noop,

  loginError: isDev
    ? (status: number | undefined, message: string) => {
        console.group(`${PREFIX} Login Error`)
        console.error('Status:', status)
        console.error('Message:', message)
        console.groupEnd()
      }
    : noop,

  cookieState: isDev
    ? (context: string) => {
        console.group(`${PREFIX} Cookie State — ${context}`)
        console.log('document.cookie:', document.cookie || '(empty — all cookies may be HttpOnly)')
        console.log('Tip: DevTools > Application > Cookies 에서 HttpOnly 쿠키 확인')
        console.groupEnd()
      }
    : noop,

  requestInterceptor: isDev
    ? (method: string, url: string, skipCheck: boolean, throttled: boolean) => {
        console.log(
          `${PREFIX} Request: ${method.toUpperCase()} ${url} | skipCheck=${skipCheck} throttled=${throttled}`,
        )
      }
    : noop,

  tokenCheck: isDev
    ? (remaining: number, isValid: boolean) => {
        console.log(`${PREFIX} Token check: remaining=${remaining}s, valid=${isValid}`)
      }
    : noop,

  unauthorized: isDev
    ? (url: string) => {
        console.error(`${PREFIX} 401 Unauthorized: ${url} — logout 실행됨`)
      }
    : noop,
}
